export default "__VITE_ASSET__Cyvtvdxm__"